import AppState from "../AppState";

export const selectUserLocale = (state: AppState): string => {
  return state.user.locale;
};
